<script setup lang="ts">
import Toolbar from 'primevue/toolbar';

const toolbarPt = {
  root: {
    class:
      'w-full min-w-0 flex-wrap gap-x-2 gap-y-1.5 !rounded-none !border-0 !border-none bg-transparent p-0 shadow-none',
  },
  start: {
    class: 'flex min-w-0 flex-1 flex-wrap items-center gap-1.5',
  },
  end: {
    class: 'flex shrink-0 flex-wrap items-center justify-end gap-1.5',
  },
};
</script>

<template>
  <Toolbar
    :pt="toolbarPt"
    class="sticky w-full py-1 px-3 md:relative md:pr-6"
  >
    <template #start>
      <slot name="start" />
    </template>
    <template v-if="$slots.end" #end>
      <slot name="end" />
    </template>
  </Toolbar>
</template>
